// src/pages/CustomerRow.js

import React from 'react';
import { TableRow, TableCell, IconButton } from '@mui/material';
import { ArrowForwardIos as ArrowForwardIcon } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import CommentsMenu from '../components/CommentsMenu';
import ImageGalleryDropdown from '../components/ImageGalleryDropdown';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';

function CustomerRow({ customer, customers }) {
  // Define images from customer's bucket, defaulting to an empty array
  const images = customer.bucket?.images || [];

  return (
    <TableRow>
      {/* Redirect Icon */}
      <TableCell>
        <IconButton
          component={Link}
          to={`/customers/${customer.id}`}
          state={{ records: customers }}
          aria-label="view-details"
        >
          <ArrowForwardIcon sx={{ fontSize: 'small' }} />
        </IconButton>
      </TableCell>
      <TableCell>{customer.firstName}</TableCell>
      <TableCell>{customer.lastName}</TableCell>
      <TableCell>{customer.address}</TableCell>
      <TableCell>{customer.phone1}</TableCell>
      <TableCell>{customer.phone2}</TableCell>
      <TableCell>{customer.email}</TableCell>
      <TableCell>
        <CommentsMenu comments={customer.comments} />
      </TableCell>
      <TableCell>
        {images.length > 1 ? (
          <ImageGalleryDropdown
            images={images}
            onUploadSuccess={null}
            onDelete={null}
            customerId={customer.id}
            readOnly={true}
          />
        ) : images.length === 1 ? (
          <a href={images[0].imageUrl} target="_blank" rel="noopener noreferrer">
            <IconButton aria-label="view image">
              <PhotoLibraryIcon sx={{ fontSize: '18px', color: 'primary.main' }} />
            </IconButton>
          </a>
        ) : null}
      </TableCell>
    </TableRow>
  );
}

export default CustomerRow;
